module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/steps-desktop@2x-a6cb166db43ae0d4ce9e4b92527c5786.png";